import o from "js-cookie";
const i = (e, t, r) => {
  o.set(e, t, { expires: r });
}, k = (e) => o.get(e), m = (e) => {
  o.remove(e);
};
export {
  k as getCookie,
  m as removeCookie,
  i as setCookie
};
